import React from 'react';
import { Store, MediaType, BookingSlot, BrandRequest } from '../../data/types';
import { MediaTypeRow } from './MediaTypeRow';
interface TimelineGridProps {
  store: Store;
  isAdmin: boolean;
  brandRequests: BrandRequest[];
  onSlotClick: (slot: BookingSlot) => void;
  onWeekClick?: (weekNumber: number) => void;
}
const mediaTypes: MediaType[] = ['Digital Outposts', 'Digital Drive Aisle', 'Digital Windows'];
export function TimelineGrid({
  store,
  isAdmin,
  brandRequests,
  onSlotClick,
  onWeekClick
}: TimelineGridProps) {
  const getSlotsByMediaType = (mediaType: MediaType): BookingSlot[] => {
    return store.slots.filter(slot => slot.mediaType === mediaType);
  };
  const formatWeekLabel = (weekNumber: number): string => {
    const baseDate = new Date('2026-03-03');
    const weekStart = new Date(baseDate);
    weekStart.setDate(baseDate.getDate() + (weekNumber - 1) * 7);
    const month = weekStart.toLocaleDateString('en-ZA', {
      month: 'short'
    });
    const day = weekStart.getDate();
    return `Week ${weekNumber} (${month} ${day})`;
  };
  return <div className="border border-border bg-white" data-id="element-1002">
      {/* Week headers */}
      <div className="flex border-b border-border" data-id="element-1003">
        <div className="w-48 flex-shrink-0 px-4 py-2 bg-surface-warm border-r border-border" data-id="element-1004">
          <span className="text-xs font-semibold text-text-secondary uppercase tracking-wide" data-id="element-1005">
            Media Type
          </span>
        </div>
        <div className="flex-1 overflow-x-auto" data-id="element-1006">
          <div className="flex gap-2 p-2 min-w-max" data-id="element-1007">
            {Array.from({
            length: 12
          }, (_, i) => {
            const weekNum = i + 1;
            return onWeekClick ? <button key={i} onClick={() => onWeekClick(weekNum)} className="w-28 flex-shrink-0 text-center text-[10px] font-medium text-text-tertiary uppercase tracking-wide py-1 rounded-sm hover:bg-surface hover:text-text-secondary transition-colors cursor-pointer" data-id="element-1008">
                    {formatWeekLabel(weekNum)}
                  </button> : <div key={i} className="w-28 flex-shrink-0 text-center text-[10px] font-medium text-text-tertiary uppercase tracking-wide" data-id="element-1009">
                    {formatWeekLabel(weekNum)}
                  </div>;
          })}
          </div>
        </div>
      </div>

      {/* Media type rows */}
      {mediaTypes.map(mediaType => <MediaTypeRow key={mediaType} mediaType={mediaType} slots={getSlotsByMediaType(mediaType)} isAdmin={isAdmin} brandRequests={brandRequests} onSlotClick={onSlotClick} data-id="element-1010" />)}

      {/* Legend */}
      <div className="flex items-center gap-6 px-4 py-3 bg-surface-warm border-t border-border flex-wrap" data-id="element-1011">
        <span className="text-xs font-medium text-text-secondary uppercase tracking-wide" data-id="element-1012">
          Legend:
        </span>
        <div className="flex items-center gap-1.5" data-id="element-1013">
          <span className="w-3 h-3 rounded-sm bg-available-bg border border-available/30" data-id="element-1014" />
          <span className="text-xs text-text-secondary" data-id="element-1015">Available</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-1016">
          <span className="w-3 h-3 rounded-sm bg-booked/20 border border-booked" data-id="element-1017" />
          <span className="text-xs text-text-secondary" data-id="element-1018">Booked</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-1019">
          <span className="w-3 h-3 rounded-sm bg-blocked border border-blocked" data-id="element-1020" />
          <span className="text-xs text-text-secondary" data-id="element-1021">Blocked</span>
        </div>
        {isAdmin && <>
            <div className="flex items-center gap-1.5" data-id="element-1022">
              <span className="w-3 h-3 rounded-sm bg-requested-bg border border-requested/50" data-id="element-1023" />
              <span className="text-xs text-text-secondary" data-id="element-1024">Brand Request</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-1025">
              <span className="w-3 h-3 rounded-sm bg-internal-bg border border-internal/30" data-id="element-1026" />
              <span className="text-xs text-text-secondary" data-id="element-1027">Woolworths</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-1028">
              <span className="w-3 h-3 rounded-sm bg-removed-bg border border-removed/30" data-id="element-1029" />
              <span className="text-xs text-text-secondary" data-id="element-1030">Removed</span>
            </div>
          </>}
      </div>
    </div>;
}